import {
  Box,
  Card,
  Grid,
  Typography,
} from "@mui/material";
import React from "react";
import ArrowDropUpRoundedIcon from "@mui/icons-material/ArrowDropUpRounded";

import CurrencyBitcoinRoundedIcon from "@mui/icons-material/CurrencyBitcoinRounded";
import { CardImageComponent } from "../../Component/Component";

const images = [
  {
    label: "Fortnite Battle Royale",
    imgPath:
      "https://i.gadgets360cdn.com/large/fortnite_keyart_1505235339110.jpg",
    status: "Private",
    project: "Comming Soon",
  },
  {
    label: "Fortnite Battle Royale",
    imgPath:
      "https://i.gadgets360cdn.com/large/fortnite_keyart_1505235339110.jpg",
    status: "Private",
    project: "Comming Soon",
  },
  {
    label: "Fortnite Battle Royale",
    imgPath:
      "https://i.gadgets360cdn.com/large/fortnite_keyart_1505235339110.jpg",
    status: "Private",
    project: "Comming Soon",
  },
  {
    label: "Fortnite Battle Royale",
    imgPath:
      "https://i.gadgets360cdn.com/large/fortnite_keyart_1505235339110.jpg",
    status: "Private",
    project: "Comming Soon",
  },
  {
    label: "Fortnite Battle Royale",
    imgPath:
      "https://i.gadgets360cdn.com/large/fortnite_keyart_1505235339110.jpg",
    status: "Private",
    project: "Comming Soon",
  },
  {
    label: "Fortnite Battle Royale",
    imgPath:
      "https://i.gadgets360cdn.com/large/fortnite_keyart_1505235339110.jpg",
    status: "Private",
    project: "Comming Soon",
  },
  {
    label: "Fortnite Battle Royale",
    imgPath:
      "https://i.gadgets360cdn.com/large/fortnite_keyart_1505235339110.jpg",
    status: "Private",
    project: "Comming Soon",
  },
  {
    label: "Fortnite Battle Royale",
    imgPath:
      "https://i.gadgets360cdn.com/large/fortnite_keyart_1505235339110.jpg",
    status: "Private",
    project: "Comming Soon",
  },
];

const PopularGames = () => {
  return (
    <Grid container sx={{marginLeft:'3%'}} spacing={2}>
      <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
        <Typography
          variant="h5"
          sx={{
            color: "#2f6df6",
            paddingTop: "6%",
            paddingLeft: "3%",
            paddingRight: "6%",
            paddingBottom: "5%",
          }}
        >
          MOST POPULAR
        </Typography>
      </Grid>
      <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
        {/* sx={{overflowY:'scroll',height:'740px'}} */}
        <Grid container spacing={2}>
          {images?.map((image, index) => {
            return (
              <Grid item xs={6} sm={6} md={3} lg={3} xl={3} key={index}>
                <CardImageComponent sx={{ height: "300px", width: "100%" }}>
                  <img
                    className="cursor-pointer"
                    src={image?.imgPath}
                    alt={image?.label}
                  />
                </CardImageComponent>
                <Grid container>
                  <Grid item lg={12}>
                    <Typography
                      variant="caption"
                      className="upcomming-project-text"
                    >
                      {image?.label}
                    </Typography>
                  </Grid>

                  <Grid item lg={12} xl={12} sx={{ display: "flex" }}>
                    <Box
                      sx={{
                        display: "flex",
                        flexDirection: "row",
                        padding: "10px",
                      }}
                    >
                      <CurrencyBitcoinRoundedIcon
                        sx={{
                          color: "black",
                          backgroundColor: "yellow",
                          borderRadius: "20px",
                          padding: "1px",
                          marginLeft: "15px",
                          fontSize: "16px",
                        }}
                      />
                      <Typography
                        variant="body2"
                        sx={{
                          margin: "5px",
                          marginLeft: "15px",
                          fontSize: "12px",
                        }}
                      >
                        $16.93
                      </Typography>
                      <Box
                        sx={{
                          display: "flex",
                          flexDirection: "row",
                          backgroundColor: "#71f34b",
                          borderRadius: "3px",
                          paddingLeft: "2px",
                          paddingRight: "3px",
                          marginLeft: "10px",
                        }}
                      >
                        <ArrowDropUpRoundedIcon
                          sx={{ color: "black", fontSize: "22px" }}
                        />
                        <Typography
                          variant="body2"
                          sx={{
                            margin: "5px",
                            marginLeft: "5px",
                            fontSize: "12px",
                            color: "black",
                          }}
                        >
                          16.25%
                        </Typography>
                      </Box>
                    </Box>
                  </Grid>
                </Grid>
              </Grid>
            );
          })}
        </Grid>
      </Grid>
    </Grid>
  );
};

export default PopularGames;
